import { css } from '@Root/lib/lit-3form-block';

// Important Note: Dipper and Mabel are twins. They are quite similar but have
// subtle differences. That said, keep in mind that a change made to one
// ** might ** also be needed in the other.

export const styles = [
  css`
    .dipper-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    /* The block sets align-items on the grid, which would collapse the shared
       rule inside its grid area; stretch it so the border-bottom lands at the
       block's bottom. */
    .horizontal-rule {
      align-self: stretch;
    }

    .default-layout {
      display: contents;

      .header {
        grid-column: 2 / 8;
        grid-row: 2;
        padding-bottom: calc(
          var(--text-stack-header-gap) - var(--block-row-gap)
        );
      }

      .description {
        grid-column: 2 / 8;
        grid-row: 3;
      }
    }

    .column-layout {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      align-items: center;

      .header {
        padding-bottom: var(--text-stack-header-gap);
      }

      .cta-wrapper {
        margin-top: var(--text-stack-cta-gap);
      }
    }

    .top-spacer {
      padding-top: calc(20rem / var(--default-rem-px-count));
    }

    .desktop-only {
      display: none;
    }

    .mobile-only {
      display: inherit;
    }

    /* Headers render at the H1 scale (20/26 -> 40/48) per the mock; the
       tag is an h2, so the smaller h2 default would otherwise apply. */
    h2 {
      font-size: var(--fs-display);
      line-height: var(--lh-display);
      letter-spacing: var(--ls-display);
    }

    /* Card titles pin the title-small scale (16/20 -> 18/24) so the
       full-size h3 default doesn't inflate them. Matches mabel. */
    h3 {
      font-size: var(--fs-title-small);
      line-height: var(--lh-title-small);
      letter-spacing: var(--ls-title-small);
    }

    img {
      width: 100%;
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 4;
      display: flex;
      flex-wrap: wrap;
      gap: var(--between-row-padding-lg);
      padding-top: calc(40rem / var(--default-rem-px-count));
    }

    .image-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;

      /* Card title and CTA share a first baseline. */
      .image-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
        padding-bottom: calc(10rem / var(--default-rem-px-count));

        /* cta-text sets align-self on its own :host; only a rule from out
           here lets it join the baseline group. */
        cta-text {
          align-self: baseline;
        }
      }

      .image {
        width: 100%;
        display: flex;
        align-items: center;
      }

      .image-description {
        padding-top: calc(20rem / var(--default-rem-px-count));
        font-size: var(--fs-body-small);
        line-height: var(--lh-body-small);
        letter-spacing: var(--ls-body-small);
        text-wrap: pretty;
      }

      /* Restore the 10px gap we lost when cta-text stopped stretching to
         fill its flex-column parent. Only apply when a cta-text actually
         follows the description. */
      .image-description.font-size-small:has(+ cta-text) {
        margin-bottom: calc(10rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 600px) {
      .dipper-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
        align-items: start;
      }

      .default-layout {
        /* Top-row texts share a first baseline. */
        .header {
          grid-column: 2 / 6;
          grid-row: 2;
          align-self: baseline;
          padding-bottom: calc(20rem / var(--default-rem-px-count));
        }

        .description {
          grid-column: 7 / 12;
          grid-row: 2;
          align-self: baseline;
        }

        .cta-wrapper {
          display: none;
        }
      }

      .column-layout {
        grid-column: 5 / 11;
        grid-row: 2;
        display: flex;
        flex-direction: column;
        align-items: center;

        .header {
          padding-bottom: calc(40rem / var(--default-rem-px-count));
          text-align: center;
        }

        p {
          text-align: center;
        }

        .cta-wrapper {
          margin-top: calc(30rem / var(--default-rem-px-count));
          width: calc(220rem / var(--default-rem-px-count));
        }
      }

      .desktop-only {
        display: inherit;
      }

      .mobile-only {
        display: none;
      }

      .images {
        grid-column: 2 / 14;
        grid-row: 3;
        display: grid;
        grid-template-columns: repeat(12, minmax(0, 1fr));
        gap: var(--between-row-padding-lg) var(--between-column-padding);
        max-width: 100%;
        padding-top: calc(60rem / var(--default-rem-px-count));
      }

      /* Card edges land on the page grid lines: halves or thirds of the
         nested 12-column grid. */
      .two-per-row > .image-wrapper {
        grid-column: span 6;
      }

      .three-per-row > .image-wrapper {
        grid-column: span 4;
      }
    }
  `,
];
